/**
 * @file Created on Mon Jan 21 2019
 * @author Tomáš Leity
 */
import rootStore from '../stores/RootStore';
import { StoreName } from '../../shared/stores/StoreName';
var keycloakStore = rootStore.getStore(StoreName.Keycloak);
export var withPermission = function withPermission(permissionTypes, some) {
  return keycloakStore.userHasPermissions(permissionTypes, some);
};